import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideOut24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowSlideOut24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M8.884 4.43a7.56 7.56 0 0 1 5.864 2.783L13.47 8.498a5.77 5.77 0 1 0-4.586 9.271 5.76 5.76 0 0 0 4.568-2.248l1.284 1.277a7.55 7.55 0 0 1-5.852 2.771l-.389-.01a7.57 7.57 0 0 1 .389-15.13m9.422 4.356a.9.9 0 0 1 1.273 0l2.502 2.502a1 1 0 0 1 .122.122l.58.58-3.204 3.202a.901.901 0 0 1-1.273-1.273l1.035-1.035H12.9a.901.901 0 0 1 0-1.801h6.43l-1.024-1.024a.9.9 0 0 1-.001-1.273"
            />
        </svg>
    );
}
export default memo(IconArrowSlideOut24);
